import ProgixRefund from "../../../components/units/Progix/Refund/ProgixRefund";

export default function ProgixRefundPage() {
  return <ProgixRefund />;
}
